class BlogArticles extends HTMLElement {
  constructor() {
    super();

    this.blogHandle = this.dataset.blogHandle;

    this.query = `query: "blog:title:-'Release Calendar'"`;
    this.cursor = 'first:6';
    this.count = 1;
    this.page = this.dataset.page;
    this.blogTotal = this.dataset.blogCount;
    this.pages =
      Math.ceil(this.blogTotal / 6) == 0 ? 1 : Math.ceil(this.blogTotal / 6);

    if (this.blogHandle != 'everything') {
      this.query = `query: "tags:#.category\\\\\\\\:${this.blogHandle} AND blog:title:-'Release Calendar'"`;
    }

    this.grid = this.querySelector('.blog__articles');
    this.nextButton = this.querySelector('[data-type="next"]');
    this.prevButton = this.querySelector('[data-type="prev"]');
    this.countSpan = this.querySelector('.blog__pagination-count');

    this.nextButton.addEventListener('click', this.handleNext.bind(this));
    this.prevButton.addEventListener('click', this.handlePrev.bind(this));

    this.updateCount();

    this.callAPI();
  }

  updateCount() {
    this.countSpan.textContent = `${this.page} of ${this.pages}`;
  }

  handleNext() {
    this.page++;
    this.callAPI({ type: 'next', key: this.nextKey });
  }

  handlePrev() {
    this.page--;
    this.callAPI({ type: 'prev', key: this.prevKey });
  }

  callAPI(cursor) {
    if (cursor) {
      if (cursor.type == 'next') {
        this.cursor = `first:6, after: "${cursor.key}"`;
      } else if (cursor.type == 'prev') {
        this.cursor = `last:6, before: "${cursor.key}"`;
      }
    }

    const graphqlQuery = `{
      articles(${this.query}, ${this.cursor}, sortKey: PUBLISHED_AT, reverse: true, ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            handle
            onlineStoreUrl            
          }
        }
      }
    }`;

    graphQL(graphqlQuery).then((res) => {
      let data = res.data ? res.data.articles.edges : [];
      let pagination = res.data
        ? res.data.articles.pageInfo
        : { hasNextPage: false, hasPreviousPage: false };

      this.nextKey = data[data.length - 1]?.cursor;
      this.prevKey = data[0]?.cursor;

      if (!pagination.hasNextPage) {
        this.nextButton.classList.add('inactive');
      } else {
        this.nextButton.classList.remove('inactive');
      }

      if (!pagination.hasPreviousPage) {
        this.prevButton.classList.add('inactive');
      } else {
        this.prevButton.classList.remove('inactive');
      }

      const promises = [];

      data.forEach((item) => {
        promises.push(
          new Promise((resolve) => {
            fetch(`${item.node.onlineStoreUrl}?section_id=article_card`)
              .then((res) => res.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(
                  responseText,
                  'text/html'
                );
                resolve(html);
              });
          })
        );
      });

      Promise.all(promises).then((htmls) => {
        this.grid.innerHTML = '';
        this.updateCount();

        htmls.forEach((html) => {
          const articleCard = html.querySelector('.card');

          const li = document.createElement('li');
          li.classList.add('grid__item', 'blog__article');
          li.innerHTML = articleCard.outerHTML;

          this.grid.appendChild(li);
        });
      });
    });
  }
}

customElements.define('blog-articles', BlogArticles);
